import { Image, Link, Taxonomies } from "@customTypes/index";
import { PresentationFields, Routes } from "@lib/constants";
import { Button, Col, Row, Space, Tag } from "antd";

interface SplitCtaProps {
  className?: string;
  flip?: string;
  showFields?: string[];
  title?: string;
  date?: string;
  description?: string;
  link: Link;
  image: Image;
  taxonomies: Taxonomies | null;
}

const defaultProps: SplitCtaProps = {
  className: "",
  flip: "start",
  showFields: [],
  title: "No title found",
  date: "March 24, 2021",
  taxonomies: null,
  description: "quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
  link: {
    url: "/",
    name: "Click Me!",
    target: "_self",
  },
  image: {
    src: "https://covrprice.com/wp-content/uploads/2020/02/STL145248.jpg",
    alt: "no image",
  },
};

const SplitCta = ({
  className,
  title,
  date,
  description,
  showFields,
  link,
  flip,
  image,
  taxonomies
}: SplitCtaProps) => {
  let direction: any = flip === 'start' ? "" : "row-reverse";
  return (
    <Row
      justify={`center`}
      gutter={[16, 16]}
      className={`covr-cta-split ${className}`}
      style={{
        flexDirection: direction,
      }}
    >
      <Col xs={23} lg={12} className="image">
        <a target={link.target} href={link.url}>
          <img
            style={{
              objectPosition: `${image?.focalPoint?.left}% ${image?.focalPoint?.top}%`
            }}
            src={image.src}
            alt={image.alt}
            loading="lazy"
          />
        </a>
      </Col>
      <Col xs={23} lg={12} className="details">
        {title
          && showFields?.includes(PresentationFields.TITLE)
          &&
          <Row>
            <Col span={24}>
              <a target={link.target} href={link.url}>
                <h3>{title}</h3>
              </a>
            </Col>
          </Row>
        }
        {date
          && showFields?.includes(PresentationFields.DATE)
          &&
          <Row>
            <Col span={24}>
              <a target={link.target} href={link.url}>
                <h4>{date}</h4>
              </a>
            </Col>
          </Row>
        }

        {description
          && showFields?.includes(PresentationFields.DESCRIPTION)
          &&
          <Row>
            <Col span={24}>
              <a target={link.target} href={link.url}>
                <p className={`mar-bot-15`}>{description}</p>
              </a>
            </Col>
          </Row>
        }

        {link.name
          && showFields?.includes(PresentationFields.LINK)
          &&
          <Row>
            <Col span={24}>
              <Button target={link.target} href={link.url} type="link">
                {link.name}
              </Button>
            </Col>
          </Row>
        }
        <Row>
          {taxonomies?.category
            && showFields?.includes(PresentationFields.CATEGORY)
            && <Col span={24}>
              <Space className={`mar-bot-5`} size={[5, 5]} wrap>
                {taxonomies.category.map((cat) =>
                  <Tag key={cat.id} color={`${cat.color}`}>
                    <a href={`${Routes.COLLECTOR_CONTENT_SEARCH}/?terms=${cat.id}`}>
                      {cat.name}
                    </a>
                  </Tag>
                )}
              </Space>
            </Col>}
          {taxonomies?.tags
            && showFields?.includes(PresentationFields.TAGS)
            && <Col span={24}>
              <Space className={`mar-bot-5`} size={[5, 5]} wrap>
                {taxonomies.tags.map((tag) =>
                  <Tag key={tag.id} color={`${tag.color}`}>
                    <a href={`${Routes.COLLECTOR_CONTENT_SEARCH}/?terms=${tag.id}`}>
                      {tag.name}
                    </a>
                  </Tag>
                )}
              </Space>
            </Col>}
        </Row>
      </Col>
    </Row>
  );
};

SplitCta.defaultProps = defaultProps;

export default SplitCta;
